const { Splide } = require("@splidejs/splide");

const contact = {
    init() {
        
/* Form contact */
        const forms = document.querySelectorAll("form.cwt-form");
        if(forms && forms.length){
            forms.forEach(form=>{
                form.addEventListener("submit", function (e) {
                    e.preventDefault();
                    form.querySelector(".message-log").innerHTML = "";
                    form.querySelector(".message-log").classList.remove('error');
                    form.querySelector("input[type='submit']").disabled = true;
                    fd = new FormData(form);
                    fetch(wp_global.ajaxurl, {
                        method: "POST",
                        body: fd,
                    })
                        .then((response) => response.json())
                        .then((res) => {
                            form.querySelector("input[type='submit']").disabled = false;
                            form.querySelector(".message-log").innerHTML = res.data.message;
                            if (res.success) {
                                form.reset();
                            } else {
                                grecaptcha.reset();
                                form.querySelector(".message-log").classList.add('error');
                            }
                        });
                });
            })
        }
    }
};

module.exports = contact;
